module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("side-bar " + (_vm.isMobileActive ? 'side-bar--active' : ''))
  }, [_c('div', {
    ref: "contracts",
    staticClass: "side-bar__row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('sideBarInfo.contracts')))]), _vm._v(" "), _c('div', {
    staticClass: "side-bar__documents"
  }, [_c('ul', {
    staticClass: "side-bar__documents__list",
    style: (_vm.documentsListWidth)
  }, [_vm._l((_vm.documents), function(doc, index) {
    return [_c('li', {
      class: ("side-bar__documents__doc " + (index === _vm.currentDocument ? 'side-bar__documents__doc--active' : '')),
      style: (_vm.documentWidth),
      attrs: {
        "data-id": index
      },
      on: {
        "click": _vm.selectDocument
      }
    }, [_c('div', {
      staticClass: "side-bar__documents__doc__image"
    }, [_c('img', {
      attrs: {
        "src": ("https://docs-cdn.signable.co.uk/large/" + (doc.fingerprint) + "-0.jpg")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "side-bar__documents__doc__image__details"
    }, [_c('b', {
      staticClass: "side-bar__documents__doc__header"
    }, [_vm._v(_vm._s(doc.title))]), _vm._v(" "), (doc.num_pages === 1) ? _c('span', {
      staticClass: "side-bar__documents__doc__subheader"
    }, [_vm._v(_vm._s(_vm.$t('sideBarInfo.onePage')))]) : _c('span', {
      staticClass: "side-bar__documents__doc__subheader"
    }, [_vm._v(_vm._s(_vm.$t('sideBarInfo.pagesPlural', {
      count: doc.num_pages
    })))])])])])]
  })], 2), _vm._v(" "), (_vm.documents.length > 1) ? _c('a', {
    staticClass: "side-bar__button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.documentNav($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": _vm.setIcon,
      "height": "20"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "parties",
    staticClass: "side-bar__row side-bar__row--scrollable"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('sideBarInfo.parties')))]), _vm._v(" "), _vm._l((_vm.parties), function(party) {
    return [_c('parties', {
      attrs: {
        "name": party.party_title,
        "email": party.party_email,
        "isSigner": party.isSigner
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "side-bar__locale"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$i18n.locale),
      expression: "$i18n.locale"
    }],
    ref: "localeSelect",
    staticClass: "side-bar__locale__select",
    attrs: {
      "id": "locale-select"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$i18n, "locale", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.saveLocale]
    }
  }, _vm._l((_vm.languages), function(lang, i) {
    return _c('option', {
      key: ("Lang" + i),
      domProps: {
        "value": lang.code
      }
    }, [_vm._v(_vm._s(lang.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    ref: "footer",
    staticClass: "side-bar__footer"
  }, [_c('a', {
    staticClass: "icon icon--circle",
    attrs: {
      "href": _vm.downloadURL
    }
  }, [_c('div', {
    staticClass: "icon__title icon__title--left"
  }, [_vm._v(_vm._s(_vm.$t('sideBarInfo.downloadPDF')))]), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "file-pdf-o",
      "height": "18",
      "width": "18"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "icon icon--circle",
    on: {
      "click": _vm.rejectDocument
    }
  }, [_c('div', {
    staticClass: "icon__title"
  }, [_vm._v(_vm._s(_vm.$t('sideBarInfo.reject')))]), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "remove",
      "width": "18",
      "height": "18"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "icon icon--circle",
    on: {
      "click": _vm.help
    }
  }, [_c('div', {
    staticClass: "icon__title"
  }, [_vm._v(_vm._s(_vm.$t('sideBarInfo.help')))]), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "question",
      "width": "18",
      "height": "18"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d40dad4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideBarInfo.vue
// module id = 1056
// module chunks = 1